import React from 'react';
import PropTypes from 'prop-types';
import { getConfigObject } from '../../util/config';
import { getPathfinderUrl } from '../../util/util';
import DefaultOverviewWidget from './OverviewWidgetComponents/DefaultOverviewWidget';
import SkillsOverviewWidget from './OverviewWidgetComponents/SkillsOverviewWidget';
import { StudentActivityContainer } from '../../StudentActivity/StudentActivity';
import { StudentCourseTotalContainer } from '../../StudentCourseTotal/StudentCourseTotal';
import s from './overviewWidget.module.css';

/**
 * Component that renders the appropriate widgets for Skills courses.
 * Responsible for component null states.
 *
 * - Renders a dynamic widget if there arewriting activies and widgets are enabled.
 * - Renders a static widget if the dynamic widgets are disabled or no writing activies.
 *
 * @param {*} props
 * @returns
 */
const SkillsWidgetContainer = (props) => {
  if (props.isSectionManager) {
    return null;
  }

  const {
    reports,
    reports: {
      courseAbstract: { id: courseId, shortId: courseShortId, enrollments },
    },
    onTabChange,
    loading,
    error,
    shouldDisplayStudentActivity,
    getLaunchUrl,
  } = props;

  const overviewWidget = reports.overviewWidget;
  const hasWritingActivity =
    overviewWidget && overviewWidget.hasWritingActivity;

  const shouldDisplaySkillsOverviewWidget =
    hasWritingActivity && enrollments !== 0;

  const noOverviewDataAfterLoading =
    !loading &&
    !shouldDisplaySkillsOverviewWidget &&
    !shouldDisplayStudentActivity;

  if (
    (!loading && !reports.authorized) ||
    error ||
    reports.comingSoon ||
    noOverviewDataAfterLoading
  ) {
    return null;
  }

  const handleISGLaunch = (studentId) => {
    if (!studentId) return;
    const performanceUrl = `performance?studentId=${studentId}`;
    props.onTabChange(performanceUrl);
  };

  const hasPathfinder =
    overviewWidget &&
    (overviewWidget.hasPathfinderActivity || overviewWidget.pathfinderUnit);
  const diagnosticsUrl = hasPathfinder ? getPathfinderUrl(courseId) : undefined;
  return (
    <div className={s.overviewWidget}>
      <div className={[s.OverviewCard, s.OverviewSkillsCard].join(' ')}>
        <h3 className={s.OverviewSection}>Insights Snapshot</h3>
        {shouldDisplayStudentActivity && (
          <>
            <StudentActivityContainer
              courseId={courseId}
              courseShortName={courseShortId}
              handleISGLaunch={handleISGLaunch}
              apiHost={getConfigObject()?.DASHBOARD_API_URL}
            />
            <StudentCourseTotalContainer
              courseId={courseId}
              handleISGLaunch={handleISGLaunch}
              apiHost={getConfigObject()?.DASHBOARD_API_URL}
            />
          </>
        )}
        {loading || shouldDisplaySkillsOverviewWidget ? (
          <SkillsOverviewWidget
            onTabChange={onTabChange}
            loading={loading}
            data={overviewWidget}
            shortId={courseShortId}
            getLaunchUrl={getLaunchUrl}
          />
        ) : (
          <DefaultOverviewWidget
            performanceTab="reports"
            diagnosticsUrl={diagnosticsUrl}
            btnText="View Details"
            widgetTitle="Course Performance Overview"
            widgetDescription="An easy snapshot of overall performance and class trends over time."
            onTabChange={onTabChange}
          />
        )}
      </div>
    </div>
  );
};
SkillsWidgetContainer.propTypes = {
  reports: PropTypes.object,
  onTabChange: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.any,
  isSectionManager: PropTypes.bool,
  shouldDisplayStudentActivity: PropTypes.bool,
  getLaunchUrl: PropTypes.func,
};

export default SkillsWidgetContainer;
